import * as actionTypes from '../actions/actionTypes';

export default function (state = null, action) {
  switch (action.type) {
    case actionTypes.FETCH_CONTACT_SUCCESS:
      return action.contact;
    case actionTypes.SUBMIT_PRIMARY_CONTACT_SUCCESS:
      return action.contact;
    case actionTypes.SUBMIT_CONTACT_SUCCESS:
      return action.contact;
    default:
      return state;
  }
}
